var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-time';
                    var viewUrl = 'sprite.svg#view-icon-time';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };